import React from 'react';
import { partnerSourcedTrend } from '../data.js';

const TIERS = [
  { label: 'Strategic', color: '#6d5bd0' },
  { label: 'Technology', color: '#0EA5A0' },
  { label: 'Reseller & Referral', color: '#E08A1F' },
];

export default function RetentionPanel({ partners = [] }) {
  const avgHealth = partners.length ? Math.round(partners.reduce((s, p) => s + p.health, 0) / partners.length) : 0;
  const max = Math.max(...partnerSourcedTrend.map((d) => d.count), 1);

  return (
    <div className="card">
      <div className="card-header">
        <div>
          <div className="card-title">Partner pipeline health</div>
          <div className="card-subtitle">Avg. relationship health across {partners.length} partners</div>
        </div>
      </div>
      <div className="card-body">
        <div className="retention-top">
          <span className="retention-value">{avgHealth}%</span>
          <span className="retention-delta">+4% vs last quarter</span>
        </div>
        <div className="retention-legend">
          {TIERS.map((t) => (
            <span className="legend-item" key={t.label}><span className="legend-dot" style={{ background: t.color }} />{t.label}</span>
          ))}
        </div>
        <div className="retention-bars">
          {partnerSourcedTrend.map((d) => (
            <div className="retention-bar-col" key={d.month}>
              <div className="retention-bar-track">
                <div className="retention-bar" style={{ height: `${(d.count / max) * 100}%` }} />
              </div>
              <span className="retention-bar-label">{d.month}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
